import React from "react";

export const ImageItem = ({image, onClick, index}) => {
    const handleClick = () => {
        onClick(index)
    }

    return <img className="file-list__item" onClick={handleClick} src={image?.compactPath}/>
};
